"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethodService = void 0;
var Base_1 = require("../Base");
var apiRoutes_1 = require("../../utils/apiRoutes");
var PaymentMethodService = /** @class */ (function (_super) {
    __extends(PaymentMethodService, _super);
    function PaymentMethodService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PaymentMethodService.prototype.getPaymentMethodAccount = function (accountId, paymentMethodId, params) {
        return this.request({
            url: (0, apiRoutes_1.paymentMethodAccountApiUrl)(accountId, paymentMethodId),
            method: 'get',
            params: params,
        }).then(function (_a) {
            var paymentMethod = _a.paymentMethod;
            return paymentMethod;
        });
    };
    PaymentMethodService.prototype.getPaymentMethodOrder = function (orderId, paymentMethodId, params) {
        return this.request({
            url: (0, apiRoutes_1.paymentMethodOrderApiUrl)(orderId, paymentMethodId),
            method: 'get',
            params: params,
        }).then(function (_a) {
            var paymentMethod = _a.paymentMethod;
            return paymentMethod;
        });
    };
    PaymentMethodService.prototype.fetchPaymentMethods = function (params) {
        return this.request({
            url: (0, apiRoutes_1.paymentMethodsApiUrl)(),
            method: 'get',
            params: params,
        }).then(function (_a) {
            var paymentMethods = _a.paymentMethods;
            return paymentMethods;
        });
    };
    PaymentMethodService.prototype.fetchPaymentMethodsAccount = function (accountId, params) {
        return this.request({
            url: (0, apiRoutes_1.paymentMethodsAccountApiUrl)(accountId),
            method: 'get',
            params: params,
        }).then(function (_a) {
            var paymentMethods = _a.paymentMethods;
            return paymentMethods;
        });
    };
    PaymentMethodService.prototype.fetchPaymentMethodsOrder = function (orderId, params) {
        return this.request({
            url: (0, apiRoutes_1.paymentMethodsOrderApiUrl)(orderId),
            method: 'get',
            params: params,
        }).then(function (_a) {
            var paymentMethods = _a.paymentMethods;
            return paymentMethods;
        });
    };
    PaymentMethodService.prototype.fetchExpressPaymentMethods = function (accountId) {
        return this.request({
            url: (0, apiRoutes_1.expressPaymentMethodsUrl)(accountId),
            method: 'get',
        });
    };
    PaymentMethodService.prototype.fetchBuyNowPayLaterMethods = function (accountId, params) {
        return this.request({
            url: (0, apiRoutes_1.paymentMethodsBuyNowPayLaterApiUrl)(accountId),
            method: 'get',
            params: params,
        });
    };
    return PaymentMethodService;
}(Base_1.BaseService));
exports.PaymentMethodService = PaymentMethodService;
//# sourceMappingURL=index.js.map